<template>
  <transition name="slide-fade">
    <div class="login">
      <div class="login-bg loginBackground" />

      <transition name="slide-fade">
        <main
          v-if="!isForgotPassword"
          class="main"
        >
          <a href="http://microba.com">
            <img
              src="../assets/images/logo-full-mono-light.png"
              alt=""
            ></a>
          <h1>Partner sign in</h1>

          <div class="box">
            <SignIn
              :api-response="apiResponse"
              :message-type="messageType"
              :hide-register-button="true"
              @eventSignIn="signIn"
              @eventCreateAccount="createAccount"
              @eventForgotPassword="isForgotPassword = true"
            />
          </div>

          <footer class="additional-info">
            <p>
              By logging in, you are agreeing to our
              <a
                :href="termsLink"
                target="_blank"
              >Terms & Conditions</a>
              and
              <a
                href="https://discover.microba.com/privacy"
                target="_blank"
              >Privacy Policy</a>
            </p>
          </footer>
        </main>
      </transition>

      <transition name="slide-fade">
        <main
          v-if="isForgotPassword"
          class="main forgot-password"
        >
          <a style="cursor: pointer"><img
            src="../assets/images/logo-full-mono-light.png"
            alt=""
            @click="isForgotPassword = false"
          ></a>

          <h1>Reset your password</h1>

          <div class="box">
            <transition name="slide-fade">
              <div
                v-if="isPasswordResetFailed"
                class="alert alert-danger"
                role="alert"
              >
                Sorry, failed to reset your password. Please try again later or contact customer service.
              </div>
            </transition>

            <div
              class="form-group has-feedback has-feedback-left col-12"
              :class="{ 'has-danger' : errors.has('email') }"
            >
              <div class="input-icon">
                <span class="oi oi-envelope-closed" />
              </div>
              <input
                id="inputEmail"
                v-model="email"
                v-validate="'required|email'"
                type="email"
                :class="{ 'is-invalid' : errors.has('email') && fields.email.touched }"
                class="form-control"
                data-vv-as="email"
                name="email"
                placeholder="Email"
              >
              <div class="text-danger">
                {{ errors.first('email') }}
              </div>
            </div>

            <div class="row">
              <Button
                text="Reset Password"
                @onClick="resetPassword"
              />
            </div>
          </div>
        </main>
      </transition>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import Button from '@/components/elements/DynamicButton.vue'
import { SignIn } from '@microbadevs/library'

export default {
  name: 'Login',
  components: {
    Button,
    SignIn
  },
  props: {
    resetPasswordTokenError: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      email: '',
      isForgotPassword: false,
      isPasswordResetFailed: false,
      apiResponse: new Object(),
      messageType: null,
      registrationUrl: process.env.VUE_APP_REGISTRATION_LINK,
      termsLink: process.env.VUE_APP_TERMS_URL
    }
  },
  mounted () {
    this.checkIfAccountIsVerified()
  },
  methods: {
    checkIfAccountIsVerified() {
      if(this.$route.query.fromVerify) this.messageType = 'VERIFY_ACCOUNT'
    },
    signIn(payload) {
      this.$store.dispatch('login', payload)
      .catch ((error) => {
        this.messageType = null
        this.apiResponse = error?.response?.data
      })
    },
    async resetPassword() {
      const isEmailValid = await this.$validator.validate()
      if (!isEmailValid) return

      this.$store.dispatch('getPasswordReset', this.email).then(() => {
        this.isForgotPassword = false
        this.isPasswordResetFailed = false
        this.messageType = 'RESET_PASSWORD_SUCCESS'
      }).catch(() => {
        this.isPasswordResetFailed = true
      })
    },
    createAccount () {
      window.location.href = this.registrationUrl
    }
  }
}
</script>
<style lang='scss'>
  body {
    -webkit-font-smoothing: antialiased;
  }
  .signin-component {
    .signin-btn {
      width: 300px;
      margin-top: 30px;
    }
    a {
      font-size: 1rem;
      font-weight: 500;
      color: #ff8708 !important;
      cursor: pointer;
    }
  }
</style>
<style lang='scss' scoped>
  body{
    background: white;
    font-family: Roboto,sans-serif !important;
    font-size: .875rem;
    font-weight: lighter;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
  }

  .login .page-report-single h2, .login h1, .page-report-single .login h2 {
    color: #fff;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .page-report-single h2, h1 {
      font-size: 3rem;
    }
  }

  input, textarea, select, button {
    text-rendering: auto;
    color: initial;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    margin: 0em;
    font: 400 11px system-ui;
  }
  .page-report-single h2, h1 {
    font-family: athelas,serif;
    font-weight: 600;
    font-size: 2.25rem;
    margin: 1rem 0;
    color: #00193d;
    letter-spacing: 1px;
  }



  .login  .main {
    box-shadow: none;
    width: 100%;
    min-height: 500px;
    min-width: 290px;
    max-width: calc(100% - 4rem);
  }

  @media (min-width: 768px){
    .login .main {
      max-width: 620px !important;
    }
  }

  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 100%;
    width: 100%;
    position: relative;
    padding: 2rem 0;
  }

  .login-bg {
    background: url('../assets/images/bg-dashboard-img.jpg') no-repeat 50% !important;
    background-size: cover;
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .login .main {
    box-shadow: none;
    width: 100%;
    min-height: 500px;
    min-width: 290px;
    max-width: calc(100% - 4rem);
  }

  .login .page-report-single h2, .login h1, .page-report-single .login h2 {
    color: #fff;
    margin-bottom: 1.5rem;
  }

  .page-report-single h2, h1 {
    font-family: athelas,serif;
    font-weight: 600;
    margin: 1rem 0;
    letter-spacing: 1px;
  }

  @media (min-width: 768px) {
    .login .box {
      padding: 41px 41px 21px;
    }
  }
  .login footer {
    text-align: center;
    font-size: 12px;
  }

  .additional-info p {
    color: #00193d;
    font-size: 1rem;
    font-weight: 300;
  }

  .login .box {
    padding: 1.75rem 1.5rem 0;
  }

  .box {
    padding: 1rem;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 2rem;
  }

  @media (min-width: 768px) {
    .input-icon ~ input {
      padding-left: 50px;
    }
  }

  input {

    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: 16px 18px;
    background-position: 98% 50%;
    cursor: auto;
  }

  .input-icon {
    position: absolute;
    width: 30px;
    height: 46px;
    z-index: 100;
  }

  .input-icon~input {
    padding-left: 40px;
  }
  .form-control {
    color: #00193d;

    font-size: 1rem;
    font-weight: 300;
    transition: background .3s ease-out,border .4s ease;
    padding: 1.4rem 1rem 1.4rem;
  }

  .btn, .btn-select .v-select, button {
    cursor: pointer;
    font-family: Roboto,sans-serif;
    font-size: 1rem;
    text-align:center;
    color: #fff;
  }

  .btn-dynamic {
    transition: all .1s;
    outline: none;
    overflow: hidden;
    min-width: 150px;
    position: relative;
    height: 42px;
    background: transparent!important;
    border-color: transparent!important;
    box-shadow: none!important;
    z-index: 2;
    width: 100%;
    max-width: 300px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 768px) {
    .login button.plain {
      width: auto !important;
    }
  }

  .login button.plain {
    float: right;
  }
  .btn-select .plain.v-select, .btn.plain, button.plain {
    color: #ff8708;
    padding: 0;
    background: transparent;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    outline: 0;
    box-shadow: none;
  }

  .additional-info p a {
    font-weight: 500;
    color: #ff8708!important;
    cursor: pointer;
  }

  a {
    color: #ff8708;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  .no-account a {
    text-transform: none;
  }

  .form-checkbox label, .form-radio label {
    cursor: pointer;
    font-weight: 300;
    color: #778598;
    padding-left: 30px;
    margin-bottom: 1rem;
  }

  .form-checkbox, .form-checkbox label, .form-radio, .form-radio label {
    position: relative;
    font-size: 1rem;
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
  }

  .radio-wrapper-outer {
    width:100%;
    display:flex;
    justify-content:center;
    padding:1rem 0rem 1rem 0rem;

    @media (min-width:768px) {
      justify-content:flex-start;
      padding:0;
    }
  }

  .radio-wrapper-inner {
    display:block;
  }

  .forgot-password {
    .row.suplimentary {
      padding-top:1.5rem;

      @media (min-width:768px) {
        padding-top:0;
      }
    }
  }


  .input-icon .faw {
    color: #778598;
    padding: 0 7px;
    margin: 1px 1px 1px 5px;
    line-height: 40px;
    font-size: 1rem;
  }

  .text-orange{
    color: #ff8708 !important;
  }

  .loginBackground{
    background: url(/img/bg-dashboard-img.c6142a06.jpg) no-repeat center center fixed !important;
    -webkit-background-size: cover !important;;
    -moz-background-size: cover !important;;
    -o-background-size: cover !important;;
    background-size: cover !important;;
  }

  footer p a {
    font-size: 16px;
    text-transform: none;
  }
</style>
